import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/layout/page-layout'
import { LocalePicker } from '@/components/locale-picker'
import { Field, FieldLabel } from '@/components/ui/field'

export const Route = createFileRoute('/_authenticated/settings')({
  component: SettingsPage,
})

function SettingsPage() {
  const { t } = useTranslation()

  return (
    <PageLayout title={t('global.settings')}>
      <div className="card">
        <Field>
          <FieldLabel>{t('settingsPage.languageLabel')}</FieldLabel>
          <div>
            <LocalePicker />
          </div>
        </Field>
        {/* <Field>
          <FieldLabel>{t('settingsPage.appearanceLabel')}</FieldLabel>
          <div>
            <ThemeToggle />
          </div>
        </Field> */}
      </div>
    </PageLayout>
  )
}
